import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import { AssistantOutlined } from '@mui/icons-material';
import { useHistory } from 'react-router-dom';

const HighlightedButton = () => {
  const isMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const history = useHistory();

  return (
    <Button
      id="buildBoardMenuOption"
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: '#232b35',
        border: 'none',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        padding: isMD ? '0px 0px 4px 8px' : '6px 0px 4px 20px',
        marginRight: '-20px',
        marginLeft: '-20px',
        width: isMD ? '100%' : '310px',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '32px',
        letterSpacing: '0.75px',
        textTransform: 'none',
        '&:hover': {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}
      onClick={() => {
        history.push('/ub/get-assistance');
      }}
      type="button"
    >
      <Box
        sx={{
          backgroundColor: '#D7F1FD',
          display: 'flex',
          paddingRight: '14px',
          alignItems: 'center',
          height: isMD ? '68px' : '58px',
          borderRadius: '12px',
          paddingLeft: '12px',
          width: '100%',
        }}
      >
        <AssistantOutlined
          style={{
            marginRight: '10px',
            marginLeft: '6px',
            fontSize: '23px',
            display: isMD ? 'none' : 'block',
          }}
        />
        <Typography
          sx={{
            fontSize: isMD ? '22px' : '14px',
            fontWeight: '500',
            letterSpacing: '-0.25px',
            textAlign: 'left',
            color: '#232B35',
            height: isMD ? '28px' : '18px',
          }}
        >
          Get Assistance
        </Typography>
      </Box>
    </Button>
  );
};

export default HighlightedButton;
